<template>
    <div :class="[orientation, {'tab-bar-bordered': border}]" class="tab-bar">
        <div :class="labelsClasses" class="tab-bar-labels" role="tablist">
            <slot/>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue, Watch} from 'vue-facing-decorator';
    import {State} from 'vuex-facing-decorator';

    @Component({
        name: 'TabBarLabels',
    })
    export default class TabBarLabels extends Vue
    {
        @State('tabBar') tabBar: Record<string, TabBarData>;

        @Prop({
            type: String,
            default: '',
            required: false,
        }) group: string;

        @Prop({
            type: Boolean,
            default: false,
            required: false,
        }) store: boolean;

        @Prop({
            type: String,
            default: 'horizontal',
            required: false,
        }) orientation: 'horizontal' | 'vertical';

        @Prop({
            type: String,
        }) paramName: string;

        @Prop({
            type: [String, Array, Object],
        }) labelsClasses: VueCssClass;

        @Prop({
            type: Boolean,
            default: false,
            required: false,
        }) border: boolean;

        @Watch('group')
        watchGroup()
        {
            this.initialize();
        }

        created()
        {
            this.initialize();
        }

        unmounted()
        {
            this.$store.commit(
                'removeTabBar',
                {
                    group: this.group,
                },
            );
        }

        private initialize()
        {
            if (this.group)
            {
                if (this.tabBar[this.group])
                {
                    // already initialized
                    return;
                }

                this.$store.commit(
                    'updateTabBar',
                    {
                        group: this.group,
                        data: {
                            store: this.store,
                            paramName: this.paramName,
                        },
                    },
                );
            }
            else if (this.store || this.paramName)
            {
                throw new Error('no group provided');
            }
        }
    };
</script>